import { useState, useEffect } from "react"
import { useContext } from "react"
import { useLocation } from "react-router-dom";
import { Loader, HandCoins } from 'lucide-react';
import { Link } from "react-router-dom";

const Unpaid = (props) => {
  const projects = props.projects;
  const unpaidProjects = projects ? projects.filter(project => project.status === "Complete" && project.paid < project.fee) : [];

  return (
    <div id="unpaidProjects">
      <div>
        <h3 className="uppercase flex p-0 gap-1 items-center">
          <HandCoins color="#ffee00" size={20}/>
          Completed+Unpaid Projects
        </h3>
        <div className="hBar mt-[7px] mb-[10px]"></div>
        <div>
          {unpaidProjects.length > 0 ? (
            <div className="max-h-[450px] flex flex-col gap-1 rounded text-xs w-full">
              {unpaidProjects.map(project => (
                <Link to="project" state={{ project_id: project.project_id }} key={project.project_id} className="blobLink hoverLeft">
                  <div className="flex flex-row gap-2 rounded py-1 px-2 justify-between text-xs w-full blobBG text-black">
                    <h4>{project.client} - {project.title}</h4>
                    <p>Due: {new Date(project.due_date).toLocaleDateString()}</p>
                    <p>Unpaid: ${Number(project.fee.replace(/[^0-9.-]+/g,"")) - Number(project.paid.replace(/[^0-9.-]+/g,""))}</p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            projects && projects.length > 0 ? (
              <p className="text-sm text-gray-300">all paid up.</p>
            ) : (
              <Loader className="spinning" />
            )
          )}
        </div>
      </div>
    </div>
  )
}


export default Unpaid